module.exports = __webpack_public_path__ + "img/savings.fbe9223.svg";